var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"svg_wrap"},_vm._l((_vm.svgList),function(item){return _c('div',{key:item.icon,staticClass:"svg_item",on:{"click":function($event){return _vm.svgSelected(item)}}},[_c('svg-icon',{attrs:{"icon-class":item.icon}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }